import "./featuredProductCard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addItem } from "../redux/cartListSlice";
import { ToastContainer, toast } from "react-toastify";
import "../assets/ReactToastify.css";

function FeaturedProductCard(product) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addItem({ slug: product.slug, quantity: 1 }));
    toast.success("Product added to cart", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleProductClick = () => {
    navigate("/product/" + product.slug);
  };

  return (
    <div
      className="product-card col mb-5 col-sd-6 wow fadeInUp"
      data-wow-duration="1"
    >
      <div className="">
        <div className="img-box" onClick={handleProductClick}>
          <img className="img mb-5 mt-5" alt="Producto" src={product.img} />
        </div>
        <div>
          <h5 className="titulo">{product.name}</h5>
        </div>
        <h4 className="precio">${product.price}</h4>

        <button
          onClick={handleAddToCart}
          className="button-agregar"
          id="btn-add"
        >
          Add to cart
        </button>
      </div>
    </div>
  );
}
export default FeaturedProductCard;
